(function() { window.GUID_1777aac3_04dd_4987_9e2f_edfe53222eae = { getGuid: function() { return "1777aac3-04dd-4987-9e2f-edfe53222eae"; } }; })();
var CS;
(function (CS) {
    var Maths;
    (function (Maths) {
        //Permet de convertir un nombre d'une échelle à une autre
        //Exemple : J'ai une échelle de 0 à 10 et je veux convertir une valeur de cette échelle de 0 à 100
        // var num = 5
        // num.map(0,10,0,100)  //retourne 50
        function RangeConveter(value, in_min, in_max, out_min, out_max) {
            return (value - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
        }
        Maths.RangeConveter = RangeConveter;
    })(Maths = CS.Maths || (CS.Maths = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-math.js.map
